<span #badgeElement
    #tooltipRef="ngbTooltip"
    [ngClass]="classes" class="badge shadow"
    [triggers]="interactiveTooltip ? 'manual' : triggers"
    [ngbTooltip]="tooltipContent || tipContent"
    [closeDelay]="closeDelay"
    (mouseenter)="onBadgeEnter(tooltipRef)"
    (mouseleave)="onBadgeLeave(tooltipRef)"
    (shown)="onTooltipShown(badgeElement, tooltipRef)"
    (hidden)="onTooltipHidden()"
    [tooltipClass]="tooltipClass">?</span>
<ng-template #tipContent>
    <div>{{message}}</div>
</ng-template>